import { ApiError } from '@myrentalmate/api-client';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Outlet } from 'react-router';

import { TwoFactorRequiredPage } from '../features/account/TwoFactorRequiredPage';
import { SignInPage } from '../features/auth/SignInPage';
import { isMfaEnrollmentRequired } from '../lib/apiError';
import { brand } from '../lib/brand';
import { useMe } from '../lib/me';

/** Signed in *and* a member of an org; otherwise show sign-in or an explanation. */
export function RequireSession() {
  const { data, error, isPending } = useMe();
  if (isPending) {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  if (error instanceof ApiError && error.status === 401) return <SignInPage />;
  if (isMfaEnrollmentRequired(error)) return <TwoFactorRequiredPage />;
  if (error || !data) {
    const noAccess = error instanceof ApiError && error.status === 403;
    return (
      <Box sx={{ p: 4 }}>
        <Typography variant="h5">
          {noAccess ? 'No organization access yet' : 'Something went wrong'}
        </Typography>
        <Typography color="text.secondary">
          {noAccess
            ? 'Ask your property manager for an invitation.'
            : `Please try again or contact ${brand.supportEmail}.`}
        </Typography>
      </Box>
    );
  }
  return <Outlet />;
}
